import React from "react";

function ResetPassword(props) {
  return (
    <>
      <div className="content-center">
        <div className="dx-popup-content dx-signin text-center">
          <h1 className="h3 text-white mb-30">Reset Password</h1>
          <form action="#" className="dx-form">
            <div className="dx-form-group-md">
              <input
                type="email"
                className="form-control form-control-style-4"
                aria-describedby="emailHelp"
                placeholder="Email"
              />
            </div>
            <div className="dx-form-group-md">
              <button className="dx-btn dx-btn-block dx-btn-popup">
                Reset My Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
